module.exports = __webpack_public_path__ + "media/images/lb/569-5e7578084c5cbf812664bd4c2a1af207.svg";